'use strict'

import _map from 'lodash/map'

import template from './edit.template.pug'

export class UserEditController {
  constructor($mdDialog, customer, SessionService, user, tasksites, $state, $mdToast, $q) {
    'ngInject'
    Object.assign(
      this,
      { $mdDialog, customer, SessionService, user, tasksites, $state, $mdToast, $q },
      {
        userData: {
          admin: !!user.isAdmin(customer),
          documents: !!user.mayAccessDocuments(customer),
          reports: !!user.mayAccessReports(customer),
          tasksites: _map(user.getAllTasksitePermissions(customer), 'tasksiteId'),
        },
      },
    )
  }

  setUserData(userData) {
    this.userData = userData
  }

  save() {
    console.log(this.userData)
    if (this.userData.admin) this.patchAdmin()
    else this.patchPermissions()
  }

  remove() {
    return this.customer
      .patchPermissions({
        email: this.user.user.email,
        permissions: [],
      })
      .then(() => {
        this.handleSuccess('Benutzer wurde erfolgreich entfernt.')
      })
  }

  cancel() {
    this.$mdDialog.cancel()
  }

  patchAdmin() {
    console.log('patchAdmin')
    this.customer
      .patchAdmin({
        email: this.user.user.email,
        documents: this.userData.documents,
        reports: this.userData.reports,
      })
      .then(() => this.handleSuccess('Berechtigungen wurden erfolgreich aktualisiert.'))
  }

  patchPermissions() {
    console.log('patchPermissions')
    this.checkNewTasksitePermission().then(() => {
      return this.customer
        .patchPermissions({
          email: this.user.user.email,
          permissions: this.userData.tasksites.map((t) => {
            return { tasksiteId: t }
          }),
        })
        .then(() => this.handleSuccess('Berechtigungen wurden erfolgreich aktualisiert.'))
    })
  }

  handleSuccess(msg) {
    this.$state.reload().then(() => {
      this.$mdDialog.hide()
      const toast = this.$mdToast.simple().textContent(msg).action('OK').position('bottom').hideDelay(10000)
      this.$mdToast.show(toast)
    })
  }

  checkNewTasksitePermission() {
    const confirm = this.$mdDialog
      .confirm({ multiple: true })
      .title('Wirklich alle Berechtigungen entziehen?')
      .textContent(
        'Wenn Sie einem Benutzer keine Standortberechtigungen zuteilen, verliert dieser sämtliche Rechte für diesen Kunden. Um Administrator- und/oder Standortberechtigungen neu zu vergeben, muss der Benutzer über das Benutzermenü neu eingeladen werden.',
      )
      .ariaLabel('Berechtigungen entziehen')
      .ok('Fortfahren')
      .cancel('Abbrechen')
    // confirm.multiple = true
    if (this.userData.tasksites.length > 0) return this.$q.resolve()
    else return this.$mdDialog.show(confirm)
  }

  confirmRemove() {
    const confirm = this.$mdDialog
      .confirm({ multiple: true })
      .title('Diesen Benutzer entfernen?')
      .textContent(
        'Sind Sie sicher, dass Sie diesen Benutzer aus ' +
          this.customer.name +
          ' - ' +
          this.customer.name2 +
          ' entfernen möchten? Diese Aktion kann nicht rückgängig gemacht werden',
      )
      .ariaLabel('Benutzer entfernen')
      .ok('Benutzer entfernen')
      .cancel('Abbrechen')
    this.$mdDialog.show(confirm).then(() => {
      this.remove()
    })
  }
}

export const userEditComponent = {
  controller: UserEditController,
  controllerAs: '$ctrl',
  clickOutsideToClose: false,
  escapeToClose: true,
  template: template(),
  fullscreen: true,
}

export const userEditConfig = ($mdDialogProvider) => {
  'ngInject'

  $mdDialogProvider.addPreset('editUser', {
    options: () => {
      return userEditComponent
    },
  })
}



// WEBPACK FOOTER //
// ./app/users/containers/edit/edit.component.js